fragment ProductSizeLabelFull on ProductSizeLabel {
  type
  values {
    xs
    s
    m
    l
  }
}
